@if (selection.length) {
  <div class="documents-container">
    <div>{{ title }}</div>
    <ul
      class="documents-container"
      cdkDropList
      (cdkDropListDropped)="onFileDropped($event)"
    >
      @for (documentSelection of selection; track documentSelection.fileId) {
        @if (isDocumentVisible(documentSelection, documentationType)) {
          <li
            class="document-element d-flex align-items-center py-2 bg-white"
            cdkDrag
          >
            <span class="icon ic-drag-and-drop-20"></span>
            <app-checkbox
              class="mr-2"
              [controlId]="'document-selection-checkbox-container-' + documentSelection.fileName"
              [label]="documentSelection.fileName ?? ''"
              [disabled]="documentSelection.mandatory || isDisabled"
              [value]="documentSelection.included || documentSelection.mandatory"
              (change)="onCheckboxChange($event, documentSelection)"
            />
          </li>
        }
      }
    </ul>
  </div>
}
